function visitRecord(value) {
  return value?.ortho_visit || value || {};
}

export function activeOrthoVisitRows(visits = []) {
  return (Array.isArray(visits) ? visits : []).filter((entry) => {
    const visit = visitRecord(entry);
    return !visit.voided_at
      && entry?.procedure_instance?.status !== "voided"
      && entry?.procedure_visit?.outcome !== "voided";
  });
}

export function orthoAdjustmentNumber(value, fallback = null) {
  const visit = visitRecord(value);
  if (String(visit.visit_type || "").toLowerCase() !== "adjustment") return null;
  const stored = Number(visit.adjustment_number || 0);
  if (stored > 0) return stored;
  const legacyFallback = Number(fallback || visit.visit_number || 0);
  return legacyFallback > 0 ? legacyFallback : null;
}

export function nextOrthoAdjustmentNumber(visits = []) {
  const numbers = activeOrthoVisitRows(visits)
    .map((entry) => orthoAdjustmentNumber(entry))
    .filter((value) => Number(value) > 0);
  return numbers.length ? Math.max(...numbers) + 1 : 1;
}

export function orthoEventLabel(value, { fallbackAdjustmentNumber = null } = {}) {
  const visit = visitRecord(value);
  const rawNoAdjustmentReason = visit.non_adjustment_reason
    || visit.no_adjustment_reason
    || visit.reason
    || visit.no_adjustment_issue
    || visit.reason_code
    || null;
  const noAdjustmentReason = {
    bracket_repair: "Bracket repair / rebond",
    wire_repair: "Wire repair / replacement",
    elastic_issue: "Elastic issue",
    other: "Other non-adjustment issue",
  }[String(rawNoAdjustmentReason || "").toLowerCase()] || rawNoAdjustmentReason;
  const isNoAdjustment = visit.no_adjustment === true
    || String(visit.no_adjustment || "").toLowerCase() === "true"
    || String(visit.visit_type || "").toLowerCase() === "no_adjustment"
    || String(visit.outcome || "").toLowerCase() === "no_adjustment";
  if (isNoAdjustment) {
    return noAdjustmentReason ? `No adjustment today · ${noAdjustmentReason}` : "No adjustment today";
  }
  switch (String(visit.visit_type || "").toLowerCase()) {
    case "bonding":
      return "Installation Day · Day 0";
    case "adjustment": {
      const number = orthoAdjustmentNumber(visit, fallbackAdjustmentNumber);
      return `Adjustment ${number || "?"}`;
    }
    case "debonding":
      return "Debonding Day";
    case "emergency":
      return noAdjustmentReason ? `No adjustment today · ${noAdjustmentReason}` : "No adjustment today";
    case "retention":
      return "Retention Visit";
    default:
      return "Ortho Visit";
  }
}
